module.exports = __webpack_public_path__ + "img/diagnostics.eb11e949.svg";